import classNames from 'classnames';
import React, { useState, useRef } from 'react';
import styles from './style.module.scss';
import DashboardWrapper from 'shared/components/common/dashboard_wrapper/DashboardWrapper';
import LayoutPo from './LayoutPo';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import { BackArrowIcon, Printer } from 'assets';
import { useReactToPrint } from 'react-to-print';
import jsPDF from 'jspdf';
import { useNavigate } from 'react-router-dom';
import { routeConstant } from 'shared/routes/RouteConstant';

export default function ViewPurchaseOrder({}) {
    const navigate = useNavigate();
    return (
        <DashboardWrapper>
            <div className={classNames(styles.UserContainer, styles.cusContainer, 'text-start')}>
                <div className={classNames(styles.cusContainer)}>
                    <div className={classNames(styles.layoutPo)}>
                    <BackArrowIcon style={{ cursor: 'pointer' }} onClick={() => navigate(routeConstant.admin.po.list.path)} />
                        <div className={classNames(styles.headingPo)}>
                            <LayoutPo />
                        </div>
                    </div>
                </div>
            </div>
        </DashboardWrapper>
    );
}
